import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "user-mobile";

const GET_ALL_USER_MOBILE = `${prefix}/all`;
const GET_USER_MOBILE_BY_ID = `${prefix}/get-user-mobile-by-id-for-web`;
const REGISTER_USER_MOBILE = `${prefix}/register-for-web`;
const UPDATE_USER_MOBILE = `${prefix}/update-by-id`;
const DELETE_USER_MOBILE = `${prefix}/delete-by-id`;

/**
 * @func getAllUserMobile
 * @desc get all user data
 * @author jew
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} user array
 */
export const getAllUserMobile = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_ALL_USER_MOBILE, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getAllUserMobile");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getAllUserMobile */

/**
 * Start
 * @func getUserMobileById
 * @desc get user mobile by id
 * @author izeberg
 * @param {number} id - user mobile id
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Object} user mobile data
 */
export const getUserMobileById = async (id, signal) => {
    try {
        const { data, status } = await axios.get(`${GET_USER_MOBILE_BY_ID}/${id}`, { signal });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getUserMobileById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getUserMobileById */

/**
 * @func registerUserMobile
 * @desc user register
 * @author jew
 * @param {Object} body - create user body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} create status
 */

export const registerUserMobile = async (body, signal) => {
    try {
        const { status } = await axios.post(REGISTER_USER_MOBILE, body, { signal });
        if (status === 201) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "registerUserMobile");
        if (err) throw err;
        return undefined;
    }
};

/** End @func registerUserMobile */

/**
/**
 * @func updateUserMobile
 * @desc update user by id
 * @author jew
 * @param {number} id - user id
 * @param {Object} body - update user body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} update status
 */
export const updateUserMobile = async (id, body, signal) => {
    try {
        const { status } = await axios.put(`${UPDATE_USER_MOBILE}/${id}`, body, { signal });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateUserMobile");
        if (err) throw err;
        return undefined;
    }
};

/** End @func updateUserMobile */

/**
 * @func deleteUserMobile
 * @desc delete user by id
 * @author jew
 * @param {number} id - user id
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} delete status
 */

export const deleteUserMobile = async (id, signal) => {
    try {
        const { status } = await axios.delete(`${DELETE_USER_MOBILE}/${id}`, { signal });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "deleteUserMobile");
        if (err) throw err;
        return undefined;
    }
};

/** End @func deleteUserMobile */
